import { render, staticRenderFns } from "./CatalogueView.vue?vue&type=template&id=5efb9465&"
import script from "./CatalogueView.vue?vue&type=script&lang=js&"
export * from "./CatalogueView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueView.vue?vue&type=style&index=0&id=5efb9465&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports